var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.googleSignInUrl}},[_c('b-img',{attrs:{"src":_vm.googleSignInButton,"alt":"Sign in with Google","width":"200"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }